import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import useHandleCategoryParentId from '../../hooks/useHandleCategoryParentId';
import SingleAemEspot from '../SingleAemEspot/SingleAemEspot';

const HomepageWrapper = ({
  espotId, storePreview,
}) => {
  const { setParentCatIdToDataBridge } = useHandleCategoryParentId();

  useEffect(() => {
    setParentCatIdToDataBridge();
  }, [setParentCatIdToDataBridge]);

  return (
    <SingleAemEspot
      espotId={espotId}
      storePreview={storePreview}
    />
  );
};

export default HomepageWrapper;

HomepageWrapper.propTypes = {
  espotId: PropTypes.string.isRequired,
  storePreview: PropTypes.string,
};
